module.exports = __webpack_public_path__ + "static/ReadingDoodle-de0f5734459c90fc9af3d6f96cde3c14.png";